import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {CustomEase} from 'gsap/CustomEase';
import {SplitText} from 'gsap/SplitText';
gsap.registerPlugin( ScrollTrigger, CustomEase, SplitText );
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
    },
    finalize: function() {
    },
    animate: function() {
      /* Basic fade up and reveal animations */
      $( `
      .js-fade:not(.js-ignore),
      .js-reveal-right:not(.js-ignore),
      .js-reveal-left:not(.js-ignore),
      .js-fade-group,
      .js-slide:not(.js-ignore),
      .js-slide-group > *:not(.js-ignore)
      ` ).each( function() {
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 90%',
            scrub: 0.15,
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                $( this ).addClass( 'js-animated' );
              }
            },
            onEnter: ( {progress, direction, isActive} ) => {
              if ( $( this ).hasClass( 'js-fade-group' ) ) {
                $( this ).find( '> *' ).each( function( childKey, child ) {
                  const delay = ( childKey + 1 ) / 10;
                  child.style.setProperty( '--fade-group-delay', delay + 's' );
                } );
              }
              $( this ).addClass( 'js-animated' );
            },
          },
        } );
      } );

      /* Used for svg animations */
      function createAnimation( elements, startAnimationObj, animationFunction, start = 'top 90%' ) {
        if ( window.hasMotion ) {
          if ( ( typeof elements === 'string' && document.querySelectorAll( elements ).length > 0 ) || ( typeof elements === 'object' && elements.length > 0 ) ) {
            gsap.set( elements, startAnimationObj );
            const triggers = ScrollTrigger.batch( elements, {
              toggleClass: 'js-animated',
              once: true,
              start: start,
              onEnter: ( batch ) => {
                animationFunction( batch );
              },
            } );

            ScrollTrigger.addEventListener( 'refreshInit', () => {
              triggers.forEach( ( trigger ) => {
                if ( trigger.progress > 0 ) {
                  animationFunction( trigger.trigger );
                }
              } );
            } );
          }
        }
      }

      /*
       * Reveal on scroll
       */
      function reveal( elements ) {
        gsap.to( elements,
            {
              clipPath: 'inset(0% 0% 0% 0%)',
              duration: 1.5,
              ease: '0, 0, 0.58, 1.0',
              stagger: 0.2, // delay e.g 0.2s
            },
        );
      }

      const drawLineClasses = '.js-draw-line:not(.js-ignore)';
      createAnimation( drawLineClasses, {clipPath: 'inset(0 100% 0 0)'}, reveal );

      /* Just needed to add js-animated - all animation is done in css */
      const drawBorderClasses = '.js-border:not(.js-ignore)';
      createAnimation( drawBorderClasses, {}, function() {} );

      if ( window.hasMotion ) {
        new SplitText( '.js-slide-group > [class*="hdg-"], [class*="hdg-"].js-slide', {type: 'lines', linesClass: 'line-wrap', tag: 'span'} );
        new SplitText( '.line-wrap', {type: 'lines', linesClass: 'line', tag: 'span'} );

        document.querySelectorAll( 'section' ).forEach( ( el ) => {
          const section = gsap.utils.selector( el );
          const sectArray = section( '.js-slide:not(.js-ignore, [class*=hdg-]), .js-slide-group > *:not(.js-ignore, [class*=hdg-]), .line, .js-fade, .js-slide-group-slow > *:not(.js-ignore, [class*=hdg-])' );

          const items = sectArray;
          if ( items.length > 0 ) {
            el.style.setProperty( '--item-total', items.length );
            sectArray.map( ( line, index ) => line.style.setProperty( '--item-index', index ) );
          }
        } );
      }
    },
    onError: function() {
      /* remove animations if there is a js error */
      const animationClasses = '.js-fade, .js-fade-group, .js-reveal-right, .js-reveal-left, .js-fade-group, .js-draw-line, .js-border, .js-slide-group, .js-slide';
      animationClasses.split( ',' ).forEach( function( selector ) {
        const className = selector.trim().replace( '.', '' ); // remove the dot
        document.querySelectorAll( selector.trim() ).forEach( function( el ) {
          el.classList.remove( className );
        } );
      } );
    },
  };
  app.registerComponent( 'animations', COMPONENT );
} )( app );
